import { render } from "./Edit.vue?vue&type=template&id=7a2df9db"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/plaintes.getourvoice.com/releases/72929466/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__